export const formDefaultValues = {
  scope: 'centres',
  visible: true,
  highlight: false,
  message: '',
}
